


import React, { useEffect, useState, useRef } from 'react'
import { Box, Typography, Grid, Modal, Button } from '@mui/material'
import { axiosInstance } from '../../../Api/Axios/axios'
import { endpoints } from '../../../Api/EndPoints/endpoints'
import { motion } from "framer-motion";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link, useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from "react-redux";
import { fetchNotices } from "../../../Redux/slices/noticeSlice";


const Initiatives = () => {

  const [data, setdata] = useState([]);

  const sectionRef = useRef(null);


  const [hasStarted, setHasStarted] = useState(false);
  const [userScrolled, setUserScrolled] = useState(false);

  const navigate = useNavigate();


  const [counts, setCounts] = useState(new Array(6).fill(0));

  const dispatch = useDispatch();
  const { notices } = useSelector((state) => state.notice);

  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(endpoints.HomeCms.getHomeCms);
      setdata(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };




  useEffect(() => {
    fetchData();

    if (!notices.length) {
      dispatch(fetchNotices());
    }
  }, [dispatch, notices.length]);


  const counterData = [
    {
      number: data?.sec3counter1_number,
      text: data?.sec3counter1_text,
    },
    {
      number: data?.sec3counter2_number,
      text: data?.sec3counter2_text,
    },
    {
      number: data?.sec3counter3_number,
      text: data?.sec3counter3_text,
    },
    {
      number: data?.sec3counter4_number,
      text: data?.sec3counter4_text,
    },
    {
      number: data?.sec3counter5_number,
      text: data?.sec3counter5_text,
    },
    {
      number: data?.sec3counter6_number,
      text: data?.sec3counter6_text,
    },
  ];


  const extractNumber = (value) => {
    return parseInt(value?.replace(/\D/g, "")) || 0;
  };
  const targetCounts = counterData.map(item => extractNumber(item.number));



  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setUserScrolled(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const isMobile = window.innerWidth < 600; // MUI xs breakpoint

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted && userScrolled && targetCounts.some(val => val > 0)) {

          setHasStarted(true);

          targetCounts.forEach((target, index) => {
            let start = 0;

            const interval = setInterval(() => {
              start += Math.ceil(target / 80);

              setCounts(prev => {
                const updated = [...prev];
                updated[index] = start >= target ? target : start;
                return updated;
              });

              if (start >= target) clearInterval(interval);
            }, 70);
          });
        }
      },
      {
        threshold: isMobile ? 0.45 : 0.7,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, [hasStarted, userScrolled, targetCounts]);



  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");

    const month = date.toLocaleString("en-US", {
      month: "short",
    });

    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  return (
    <>
      <Box

        component={motion.div}
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        ref={sectionRef}

        sx={{ width: '100%', minHeight: '400px', display: 'flex', flexDirection: { sm: "row", xs: "column" } }}
      >


        {/* LEFT CARD */}
        <Box
          sx={{
            width: { sm: '50%', xs: "100%" },
            height: '450px',
            background: 'linear-gradient(90deg, #1BAA63 0%, #276f9e 100%)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',

            "&::before": {
              content: '""',

              inset: 0,
              background:
                "linear-gradient(120deg, transparent 30%, rgba(255,255,255,.25), transparent 70%)",
              transform: "translateX(-100%)",
              animation: hasStarted ? "shine 2s ease forwards" : "none",
            },

            "@keyframes shine": {
              to: { transform: "translateX(100%)" },
            },

          }}

        >

          <Grid container spacing={2} sx={{ width: '90%' }}>
            {counterData.map((item, index) => (
              <Grid
                item
                size={{ xs: 6, sm: 6, md: 4 }}
                key={index}
                sx={{
                  marginTop: "40px",
                  marginBottom: "40px",
                  position: 'relative',

                  /* RIGHT BORDER */
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: '20%',
                    right: 0,
                    height: '60%',
                    width: '1px',
                    backgroundColor: 'rgba(255,255,255,0.4)',


                    display: {
                      xs: (index + 1) % 2 === 0 ? 'none' : 'block',
                      md: (index + 1) % 3 === 0 ? 'none' : 'block',
                    },
                  },
                }}
              >
                <Box textAlign="center">
                  <Typography
                    sx={{
                      fontSize: { xs: '28px', md: "36px" },
                      fontWeight: 700,
                      fontFamily: 'Roboto',
                      color: '#fff',
                      lineHeight: '100%',
                    }}
                  >
                    {item.number?.includes("+")
                      ? `${counts[index]}+`
                      : counts[index]}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: '15px', md: "16px" },
                      fontFamily: 'Roboto',
                      color: '#fff',

                    }}
                  >
                    {item.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>


        </Box>

        {/* RIGHT CARD (UNCHANGED) */}
        <Box
          sx={{
            width: { sm: "50%", xs: "100%" },
            height: "450px",
            position: "relative",
            overflow: "hidden",
            cursor: "pointer",

            /* BACKGROUND LAYER */
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${data?.notice_bg_img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "transform 1.2s ease",
              zIndex: 0,
            },

            /* SHINE OVERLAY */
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(120deg, transparent 30%, rgba(255,255,255,.35) 50%, transparent 70%)",
              transform: "translateX(-120%)",
              transition: "all 1.2s ease",
              zIndex: 1,
              pointerEvents: "none",
            },

            "&:hover::before": {
              transform: "scale(1.08)",
            },

            "&:hover::after": {
              transform: "translateX(120%)",
            },

            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",

            /* keep content above overlays */
            "& > *": {
              position: "relative",
              zIndex: 2,
            },

            "&:hover .scrollContent": {
              animationPlayState: "paused",
            },

          }}

        >


          <Box
            sx={{
              width: "90%",
              height: "90%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* HEADING */}
            <Box
              sx={{
                textAlign: "center",
                marginBottom: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.2,
                mb: "25px"
              }}
            >
              <NotificationsActiveIcon
                sx={{
                  color: "#FFD700",
                  fontSize: 28,
                  animation: "ring 1.5s ease-in-out infinite",
                }}
              />

              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 900,
                  textTransform: "uppercase",

                  color: "#111827",

                  background: "rgba(255,255,255,0.75)",
                  px: 2,
                  py: 0.5,
                  borderRadius: "10px",

                  backdropFilter: "blur(8px)",

                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                }}
              >
                {data?.notice_title}
              </Typography>



              {/* Bell Ring Animation */}
              <style>
                {`
                          @keyframes ring {
                         0% { transform: rotate(0); }
                         10% { transform: rotate(15deg); }
                          20% { transform: rotate(-10deg); }
                          30% { transform: rotate(6deg); }
                          40% { transform: rotate(-4deg); }
                          50% { transform: rotate(2deg); }
                          60% { transform: rotate(0); }
                          100% { transform: rotate(0); }
                           }
                            `}
              </style>
            </Box>


            <Box
              sx={{
                flex: 1,
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Box
                className="scrollContent"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1, md: 2 },

                  // ✅ CONDITION
                  animation:
                    notices.length > 4
                      ? "scrollUp 10s linear infinite"
                      : "none",

                  willChange: "transform",

                  "@keyframes scrollUp": {
                    "0%": {
                      transform: "translateY(0%)",
                    },

                    "100%": {
                      transform: "translateY(-50%)",
                    },
                  },
                }}
              >
                {[...notices].map((item, index) => (
                  <Box
                    key={item.id}
                    // component={Link}
                    // to={`/notice/${item.id}`}

                    onClick={() => navigate(`/notice/${item.id}`)}

                    // href={item.link}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 2,
                      textDecoration: "none",
                      color: "#000",
                      backgroundColor: "rgba(255,255,255,0.9)",
                      padding: "10px",
                      borderRadius: "4px",
                      transition: "all .3s ease",

                      "&:hover": {
                        backgroundColor: "#fff",
                        transform: "translateX(5px)",
                      },
                    }}
                  >
                    {/* DATE */}

                    <Box
                      sx={{
                        minWidth: "140px",
                        background: "linear-gradient(135deg, #1BAA63 0%, #276f9e 100%)",
                        color: "#fff",
                        fontSize: { xs: "14px", md: "16px" },
                        fontWeight: 600,
                        padding: "6px 10px",
                        textAlign: "center",
                        borderRadius: "4px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                      }}
                    >
                      {formatDate(item.date)}
                    </Box>


                    {/* 📄 TITLE */}
                    <Typography
                      sx={{
                        fontSize: { xs: "16", md: "18px" },
                        fontWeight: 500,
                        lineHeight: 1.4,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: "auto",
                pt: 6
              }}
            >



              <Button
                variant="contained"
                endIcon={<ArrowForwardIosIcon sx={{ fontSize: 14 }} />}
                sx={{
                  alignSelf: { xs: "stretch", sm: "flex-start" },
                  // mt: 2,
                  px: { xs: 1.8, sm: 2.2, md: 2.4 },
                  py: { xs: 0.7, sm: 0.8 },
                  fontSize: { xs: "16px", sm: "17px" },
                  borderRadius: "30px",
                  textTransform: "none",
                  fontWeight: 600,

                  position: "relative",
                  overflow: "hidden",

                  background: "#bd2304",


                  zIndex: 1,

                  "& span": {
                    position: "relative",
                    zIndex: 2,
                  },


                  "&:before": {
                    content: '""',
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    width: 0,
                    height: 0,
                    background: "#000",
                    borderRadius: "50%",
                    transform: "translate(-14%, -50%)",
                    transition: "all 1s ease",
                    zIndex: 0,
                  },

                  "&:hover:before": {
                    width: "300%",
                    height: "300%",
                  },

                  "&:hover": {
                    background: "#bd2304",
                  },
                }}
                onClick={() => navigate("/all-notices")}
              >
                <span>  View All Notices</span>
              </Button>
            </Box>

          </Box>





        </Box>

      </Box>
    </>
  );
};

export default Initiatives;